import script from "./UndanitasCDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UndanitasCDialog.vue?vue&type=script&setup=true&lang=js"

import "./UndanitasCDialog.vue?vue&type=style&index=0&id=6e97a798&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e97a798"]])

export default __exports__